export default __webpack_public_path__ + "static/media/mobileHero.17c3ba79.png";